'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import { useState } from 'react';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Service } from '../../types/service';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '@eliadmin/core/src/components/ui/button';

export const ServiceCard = ({ service }: { service: Service }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <div
      className={cn(
        'group transition-all hover:border-primary hover:bg-primary',
        'col-span-1 flex h-fit w-full flex-col items-start justify-start gap-8 border border-[#D8D8DB] p-8',
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image
        src={service.image.url}
        alt={resolveImageAlt(service?.image, service?.name)}
        width={56}
        height={56}
        className="fill-white stroke-white text-white"
      />
      <h3
        className={cn(
          'transition-all group-hover:text-white',
          'text-ellipsis text-2xl font-semibold text-black md:text-3xl lg:h-[178px] xl:h-[110px]',
        )}
      >
        {service.name}
      </h3>
      <Button
        asChild
        variant={isHovered ? 'secondary' : 'default'}
        className={cn('ea-service-default__shadow', 'ea-service-card__button')}
      >
        <Link href={service.slug} aria-label={`Viac o službe: ${service.name}`}>
          VIAC O SLUŽBE
        </Link>
      </Button>
    </div>
  );
};
